module.exports = __webpack_public_path__ + "img/live-end.290e3e8a.png";